export const PROCUREMENT_STATUS = {
  DRAFT: "DRAFT",
  IN_REVIEW: "INREVIEW",
  APPROVED: "APPROVED",
};

